import { preloadPostOfficeConfluenceSideNav } from '@confluence/experiment-post-office-side-nav/entry-points/preloadConfluenceSideNav.ts';
import { fg } from '@confluence/feature-gating';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { preloadUseExtensionList } from '@confluence/forge-ui/entry-points/preloadUseExtensionList.ts';
import { FORGE_MODULE_SPACE_PAGE } from '@confluence/forge-ui/entry-points/ForgeModuleType.ts';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation.ts';
import { getIsNav4Enabled } from '@confluence/nav4-enabled/entry-points/getIsNav4Enabled.ts';
import { preloadPersistentInviteButtonEligible } from '@confluence/persistent-invite-button/entry-points/preloadPersistentInviteEligible.ts';

import SpaceNavigationQuery, {
	type SpaceNavigationQuery$data,
	type SpaceNavigationQuery$variables,
} from './SpaceNavigation/__generated__/SpaceNavigationQuery.graphql.ts';

export async function preloadSideNavigation(spaceKey: string) {
	const preloadedSessionContext = getPreloaderFnContext();
	const isNav4Enabled = getIsNav4Enabled();

	const tasks: Array<Promise<any>> = [];

	tasks.push(
		query<SpaceNavigationQuery$data, SpaceNavigationQuery$variables>({
			query: SpaceNavigationQuery,
			variables: {
				spaceKey,
				isLicensed: preloadedSessionContext.isLicensed,
			},
		}),
	);

	tasks.push(
		preloadUseExtensionList({
			spaceKey,
			moduleType: FORGE_MODULE_SPACE_PAGE,
		}),
	);

	tasks.push(preloadPersistentInviteButtonEligible({ spaceKey }, false));

	if (isNav4Enabled) {
		tasks.push(
			preloadWebItemLocation({
				location: 'system.header/left',
			}),
		);
	}

	if (fg('po-connie-side-nav-ssr-shadow')) {
		tasks.push(preloadPostOfficeConfluenceSideNav(preloadedSessionContext));
	}

	return waitForAllReturnWhenError(tasks);
}
